import styled from "styled-components";

export const Container = styled.section`
  .accordion {
    padding: 3rem 1.5rem;
    h3 {
      font-size: 2rem;
      text-align: center;
      color: #444444;
      margin-bottom: 3rem;
    }
  }

  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 1440px) {
  }
`;
